import { isAxiosError } from 'axios';

type ApiErrorResponse = {
  message?: string;
  errors?: Record<string, string[]>;
};

const firstValidationError = (errors?: ApiErrorResponse['errors']) => {
  if (!errors) return undefined;

  return Object.values(errors).find((messages) => messages.length)?.[0];
};

export const getApiErrorMessage = (
  error: unknown,
  fallback = 'Something went wrong. Please try again.',
) => {
  if (isAxiosError<ApiErrorResponse>(error)) {
    return (
      error.response?.data?.message ||
      firstValidationError(error.response?.data?.errors) ||
      error.message ||
      fallback
    );
  }

  if (error instanceof Error) {
    return error.message;
  }

  return fallback;
};
